module.exports = __webpack_public_path__ + "static/media/arrow-right.73673342.svg";